import React from "react";

export default function ModeCard({
  icon: Icon,
  title,
  description,
  best,
  footerLabel = "Best",
  bestUnit,
  footerExtra,
  badge,
  valueColor = "text-emerald-400",
  onClick,
  comingSoon,
}) {
  const disabled = !!comingSoon;

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`relative text-left rounded-2xl border p-6 transition group flex flex-col
        ${
          disabled
            ? "bg-zinc-900/20 border-zinc-900 opacity-60 cursor-not-allowed"
            : "bg-zinc-900/50 border-zinc-800 hover:border-emerald-500/50 hover:bg-zinc-900/70 cursor-pointer"
        }`}
    >
      {comingSoon ? (
        <span className="absolute top-3 right-3 text-[9px] uppercase tracking-widest text-zinc-500 bg-zinc-900 border border-zinc-800 rounded-full px-2 py-0.5">
          Coming soon
        </span>
      ) : badge ? (
        // <span className="absolute top-3 right-3 text-[10px] font-bold text-emerald-300 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-2 py-0.5 tabular-nums">
        //   {badge}
        // </span>
        <div className="absolute top-3 right-3">{badge}</div>
      ) : null}

      <div
        className={`w-12 h-12 rounded-xl grid place-items-center mb-4
          ${
            disabled
              ? "bg-zinc-900 text-zinc-700"
              : "bg-emerald-500/10 text-emerald-400 group-hover:bg-emerald-500/15 transition"
          }`}
      >
        {Icon && <Icon className="w-6 h-6" />}
      </div>

      <h2 className="text-lg font-bold text-zinc-100 mb-1">{title}</h2>
      <p className="text-sm text-zinc-400 mb-6 flex-1">{description}</p>

      <div className="pt-4 border-t border-zinc-800 flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-widest text-zinc-500">
          {footerLabel}
        </span>
        <div className="ml-auto flex items-baseline gap-3">
          {footerExtra}
          {best && typeof best === "object" ? (
            <div className="flex items-center gap-5">
              <div className="text-xs tabular-nums">
                <span className="text-emerald-400 font-semibold">
                  {best.wins}
                </span>
                <span className="text-zinc-700 mx-0.5">·</span>
                <span className="text-zinc-400">{best.draws}</span>
                <span className="text-zinc-700 mx-0.5">·</span>
                <span className="text-red-400">{best.losses}</span>
              </div>
              <span className="text-sm font-bold text-emerald-400">
                {best.rating}
              </span>
            </div>
          ) : best != null && best !== "—" ? (
            <span className="text-sm font-semibold tabular-nums">
              <span className={valueColor}>{best}</span>
              {bestUnit && (
                <span className="text-zinc-500 ml-1">{bestUnit}</span>
              )}
            </span>
          ) : (
            <span className="text-sm font-semibold text-zinc-200 tabular-nums">
              —
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
